<template>
  <div class="termDetails">
    <div v-if="showTitle" class="title lg">
      智选保代隐私政策
    </div>
    <p class="indent">本政策于2023年【3】月【1】日更新并生效。</p>
    <p class="indent">您的信任对我们非常重要，我们深知您的个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全。除非另有说明，本《智选保代隐私政策》（以下简称“本政策 ”）适用于广东智选保险代理有限公司及其关联公司（以下简称“智选保代”或“我们”）向您提供的产品和服务。本政策旨在向您说明我们对您个人信息的处理规则，包括但不限于如何在为您提供产品和服务的过程中收集、使用、存储、提供您的个人信息等。</p>
    <p class="indent">请您在使用我们的产品和服务前，认真阅读本政策，充分了解本政策的全部内容。<span class="bold">对本政策中与您的权益存在重大关系的条款和敏感个人信息，我们将采用字体加粗及下划线以提示您注意。</span>请您确保对其内容特别是字体加粗及下划线内容的含义及相应法律后果已全部知晓并充分理解，您通过与我们签订书面合作协议或勾选“同意”即视为您接受本政策。</p>
    <p class="indent">如您通过我们的产品和服务使用第三方（包括但不限于保险公司等）提供的服务，相应的第三方可能依据其个人信息保护政策（可能为“隐私政策”，具体名称以第三方提供的为准）直接向您收集个人信息，请您仔细阅读第三方服务商的/隐私政策。我们对第三方的个人信息保护义务与履行不作任何保证与承诺，但会通过书面声明等方式提示第三方服务商遵守相关法律法规的要求。</p>
    <p class="indent bold">请注意，如您在使用我们服务时将我们的服务授权于他人使用，或通过上传照片或文字等方式向我们提供其他人的个人信息，请您务必使该用户充分阅读理解本政策并取得该用户的充分的、明确的、合法的授权同意。若该用户或/及我们因您的疏忽而遭受任何损失，该损失将由您来承担。</p>
    <p class="indent">
      <div class="bold">一、我们如何收集和使用您的个人信息</div>
      <div class="bold close">（一）注册、登录</div>
      <div class="indent close">为了帮助您可以直接登录我们的产品和服务，我们将从小鹏汽车APP（以下简称“小鹏汽车”）获取您已注册的小鹏账号信息（含<span class="bold underline">手机号码</span>），并便于您可以享受我们不定期对小鹏汽车车主提供的特定权益。</div>
      <div class="bold">（二）车险咨询、投保</div>
      <div class="indent close">为了帮助您可以了解和购买车险产品和服务，我们将收集您及您关系人的以下信息<span class="underline"><span class="bold">：姓名，身份证（或护照、军人证、居住证），出生日期、性别、民族、国籍、手机号，电子邮箱或地址，行驶证、车辆信息</span>（如车牌号、是否过户、车辆类型、号牌类型、车架号、使用性质、发动机号、车辆登记日期、整备质量、号牌型号、座位数）<span class="bold">，车辆保险订单及其他</span></span>根据法律法规或受保险公司委托要求投保所必需的信息，具体范围可能会因您选择的保险公司、险种、投保期间及保费而不同，具体以保单必需载明范围为准。</div>
      <div class="indent close">用于以下目的：（1）确认您的身份及车险投保的真实性；（2）确认您选择的保险产品，以提供报价、投保等服务；（3）保险公司向您发送或邮寄保单、保险产品条款相关的保险单证等资料；（4）其他您选择的保险公司的个人信息处理规则所载明的处理目的。上述信息系投保所必需的信息，如您拒绝我们收集上述信息，我们将无法为您提供相关服务。</div>
      <div class="indent close">在向您提供保险投保服务过程中，基于法律法规要求，我们可能会根据保险公司的委托，向保险公司申请核验您的身份信息的真实性，对此，您亦授权我们<span class="bold underline">收集并留存</span>在您填写或选择的上述个人信息及保险订单及投保所必需的信息。</div>
      <div class="bold">（三）订单管理</div>
      <div class="indent close">为了帮助您可以随时查阅相关保险信息并享受相关保险或维修服务，我们会在您完成投保后向小鹏汽车提供保单及出险相关信息，包括：<span class="bold underline">保险公司编码及名称、投保时间、保单列表、子险列表、车辆信息、投保类型、保单信息、电子保单、出险信息以及收款信息</span>（具体以系统页面展示为准）。</div>
      <div class="bold">（四）咨询、申诉及争议处理</div>
      <div class="indent close">当您向我们进行服务咨询、申诉、投诉时，我们可能需要您的<span class="bold underline">姓名、手机号码</span>及其他由您主动提供的信息，用于以下目的：（1）在必要时核验用户身份；（2）处理关于用户个人信息的相关请求，如更正、补充用户个人信息等；（3）回复用户咨询、投诉，或者处理与用户的法律争议。</div>
      <div class="indent close">如果您拒绝提供实现前述所需的所有信息，可能影响您申诉或投诉的处理效率，或者无法及时处理您的申诉或者投诉。</div>
      <div class="bold">（五）系统权限</div>
      <div class="indent close">为向您提供您所选择使用的本政策前述所说明的服务，或者保证服务的质量和体验，可能需要您授权开启操作系统的相关权限。如果您不同意授权我们获取相关操作系统权限，不会影响您使用我们提供的其他无需该等权限的业务功能（业务功能所依赖的必要操作系统权限除外），但您可能无法获得相应附加服务给您带来的用户体验。具体涉及的权限情况如下：</div>
      <div class="indent close">1、存储权限，用于读取本地图片、上传图片。</div>
      <div class="indent close">2、电话权限，用于唤起拨打电话功能，以联系客服、网点服务人员。</div>
      <div class="indent close">3、相机及相册权限，当您使用拍照识别身份证、行驶证等功能时，您需要开启摄像头权限和/或相册权限（以您使用的具体功能为准），以便您进行实时拍摄或图片/视频上传。</div>
      <div class="indent close">4、位置权限，当您使用车险投保功能时，为了解、核实您所在的城市，我们会向您申请定位权限。</div>
    </p>
    <p class="indent">
      <div class="bold">二、我们如何委托处理、提供、公开您的个人信息</div>
      <div class="bold close">（一）委托处理</div>
      <div class="indent close">我们可能会委托关联公司或其他专业服务提供商代表我们为您提供某些服务或履行职能，对我们委托处理信息的公司、组织和个人，我们将采取如下保护您的个人信息的措施：</div>
      <div class="indent close">1、我们将与受托人约定委托处理范围及个人信息保护措施；</div>
      <div class="indent close">2、我们将对受托人的个人信息处理活动进行监督，要求受托人严格按照约定处理个人信息，遵守保密义务，采取有效的个人信息保护措施，禁止受托人将您的个人信息用于未经您授权的处理目的，或采用未经您授权的处理方式；</div>
      <div class="indent close">3、委托关系解除时，我们将要求受托人不得保留您的个人信息。</div>
      <div class="bold close">（二）提供</div>
      <div class="indent close">我们不会向任何第三方公司、组织和个人提供您的个人信息，但以下情况除外：</div>
      <div class="indent close">1、根据法律法规规定或政府主管部门要求，我们可能需要对外提供您的个人信息。</div>
      <div class="indent close">2、为了便于保险公司向您提供核保、保单费用支付等保险服务，我们将根据保险公司委托，将您使用车险代理功能相关的个人信息提供给您选择的保险公司，请您于选择保险公司或车险产品前，充分理解并同意相应保险公司的个人信息处理规则。保险机构目录可于车险产品和/或服务页面进行查询，或在具体机构确定后，我们将以适当的方式及时告知/披露其具体名称和联系方式</div>
      <div class="indent close">3、为便于我们与关联公司共同向您提供部分服务，我们会在遵循统一管理和控制的关联公司之间共享您的信息，且受本隐私政策中所声明目的的约束。</div>
      <div class="indent close">4、原则上我们不会将您的个人信息控制权向其他公司、组织或个人进行转移。如为合并、收购或资产出售等交易的需要，我们可能会将您的个人信息进行转移。在转移您的个人信息前，我们会给予您适当通知（包括通知您接收方的名称或者姓名和联系方式）。同时，我们会要求新的持有您信息的公司、组织继续受本政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</div>
      <div class="bold close">（三）公开</div>
      <div class="indent close">我们仅会在以下情况下，公开您的个人信息：</div>
      <div class="indent close">1、获得您明确且单独同意的；</div>
      <div class="indent close">2、依据法律法规的规定，或按政府机构、监管部门、司法机构的强制性要求公开披露您的个人信息。在此种情况下，我们将公开披露您的个人信息。</div>
    </p>
    <p class="indent">
      <div class="bold">三、我们如何存储和保护您的个人信息安全</div>
      <div class="bold close">（一）个人信息的存储</div>
      <div class="indent close">1、存储地点：原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。以下情形除外：</div>
      <div class="indent close">（1）法律法规有明确规定；</div>
      <div class="indent close">（2）获得您的授权同意；</div>
      <div class="indent close">针对以上情形，我们会确保依据本政策及国家法律法规要求对您的个人信息提供足够的保护，且严格要求接收方按照本政策以及中华人民共和国法律法规相关要求来处理您的个人信息。</div>
      <div class="indent close">2、存储期限：</div>
      <div class="indent close">我们仅在本政策所述目的，或按保险公司委托要求，或按您关于车险代理服务的特别要求所必需且最短的期间内，或法律法规要求的时限内保留您的信息。在超出上述存储期限后，或在您行使个人信息删除权的情况下，我们会对您的个人信息进行删除或匿名化处理。</div>
      <div class="indent close">但在下列情况下，我们有可能因需符合法律要求，调整个人信息的存储时间：</div>
      <div class="indent close">（1）为遵守适用的法律法规等有关规定；</div>
      <div class="indent close">（2）为遵守法院判决、裁定或其他法律程序的规定；</div>
      <div class="indent close">（3）为遵守相关政府机关或法定授权组织的要求；</div>
      <div class="indent close">（4）为维护社会公共利益，为保护我们的用户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。</div>
      <div class="indent close">3、终止运营：</div>
      <div class="indent close">如我们停止运营车险代理相关产品及服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以推送通知或公告的形式通知您，并在合理的期间内对所持有的个人信息进行删除或匿名化处理。</div>
      <div class="bold">（二）个人信息的保护</div>
      <div class="indent close">我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。虽然我们采取了合理的措施保护您的信息，<span class="bold underline">但没有任何网站、计算机系统或无线连接是绝对安全的。</span>在发生安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低风险的建议、针对您的具体情况应采取的补救措施等。我们将及时将事件相关情况以短信通知、电话、邮件等您向我们的预留的联系方式告知您，难以逐一告知的，我们会采取合理、有效的方式发布公告。如果您认为我们的系统存在任何安全风险或漏洞，请根据本政策“联系我们”部分所列的方式与我们联络。 请您妥善保护自己的个人信息，仅在必要的情形下向他人提供，并请使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络客服，以便我们根据您的申请采取相应措施。</div>
    </p>
    <p class="indent">
      <div class="bold">四、您如何行使自己的权利</div>
      <div class="indent close">我们将根据相关法律法规尽力保证您的个人信息的权利。在您行使您的权利时，我们可能要求您提供相应的身份证明，以保证您的个人信息安全。</div>
      <div class="indent close">为保障您的查阅、复制、更正、补充、删除等法定权利。<span class="bold">您可以通过本政策“联系我们”约定的热线电话或者其他方式与我们取得联系，并提出行使相关权利的请求，</span>我们将在收到您的申请后的十五（15）个工作日内，验证您的身份并回复处理意见或结果。</div>
      <div class="indent close">对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</div>
    </p>
    <p class="indent">
      <div class="bold">五、未成年人个人信息保护</div>
      <div class="indent close">未成年人在使用我们的产品与/或服务或向我们提供您的个人信息前，应事先取得其父母或法定监护人的同意。</div>
      <div class="indent close">我们根据国家相关法律法规的规定保护未成年人用户的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下处理未成年人的个人信息；如果我们发现在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。</div>
    </p>
    <p class="indent">
      <div class="bold">六、联系我们</div>
      <div class="indent close">如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索希望投诉举报，或者您对本政策有任何疑问、意见或建议，或有任何隐私投诉或权利请求，可通过以下方式与我们联系：</div>
      <div class="indent close">（1）拨打客服电话020-61938236</div>
      <div class="indent close">（2）邮寄至地址：广州市南沙区环市大道中29号2222房。（需注意的是，我们可能不会回复与本政策或您的个人信息权利无关的问题。）</div>
      <div class="indent close">一般情况下，我们将尽快审核您提出的问题或建议，并在验证您的用户身份后的十个工作日内回复。</div>
    </p>
    <p class="indent">
      <div class="bold">七、政策更新</div>
      <div class="indent close">我们的产品和服务将不断跟随您以及其他的用户的需求更新和优化，因此可能会不时修订和更新我们的隐私政策。如果我们对个人信息处理规则作出重大变更，我们将及时发布最新的隐私政策。除另有声明的，我们的个人信息处理规则应适用于最新有效的《智选保代隐私政策》。</div>
      <div class="indent close">请您确保充分阅读、理解并同意修订后的《智选保代隐私政策》，未经您的同意，我们不会限制您在本政策下享有的权利。如果您对个人信息保护政策的更新有任何疑问、建议，请通过“联系我们”与我们取得联系。</div>
    </p>
  </div>
</template>
<script>
export default {
  name: 'PrivatePolicy',
  props: {
    showTitle: {
      type: Boolean,
      default: false
    }
  }
};
</script>